// packages
import { createTrendsFeed } from './stores.js';

import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import USHouseTrends from './components/USHouseTrends.svelte';
import SenateTrends from './components/SenateTrends.svelte';

async function main() {
  const trendsFeed = await createTrendsFeed();

  // container id -> trends component and u.s. house or senate slice of the feed
  const chambers = [
    {
      elementId: 'hp-house-embed',
      component: USHouseTrends,
      chamberTrendsFeed: derived(
        trendsFeed,
        ($feed) => $feed.data?.attributes?.house
      ),
    },
    {
      elementId: 'hp-senate-embed',
      component: SenateTrends,
      chamberTrendsFeed: derived(
        trendsFeed,
        ($feed) => $feed.data?.attributes?.senate
      ),
    },
  ];

  for (const { elementId, component, chamberTrendsFeed } of chambers) {
    // find the container
    const element = findElementByIdInShadowDom(elementId);

    if (element) {
      // render
      renderSvelteComponent(
        component,
        /** @type {HTMLElement} */
        element,
        {
          feed: chamberTrendsFeed,
        }
      );
    }
  }
}

main().catch(console.error);
